/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_EyebrowInputs */

const en_home_direct_eyebrow = /** @type {(inputs: Home_Direct_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why book with Ollio`)
};

/**
* | output |
* | --- |
* | "Why book with Ollio" |
*
* @param {Home_Direct_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_eyebrow = /** @type {((inputs?: Home_Direct_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_eyebrow(inputs)
});